import React from "react";
import { useNavigate } from "react-router-dom";
import { LuArrowLeft, LuHome, LuLogIn, LuSearchX } from "react-icons/lu";

import ErrorState from "../../components/errors/ErrorState";
import QuickLinks from "../../components/errors/QuickLinks";
import AppLayout from "../../components/layout/AppLayout";
import AuthLayout from "../../components/layout/AuthLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import Button from "../../components/ui/Button";
import { cardClass, pageTitleClass } from "../../components/ui/styles";
import { useAuth } from "../../context/AuthContext";
import { route } from "../../static/route";
import { BreadcrumbType } from "../../types/common";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "પેજ મળ્યું નથી" },
];

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const authToken = localStorage.getItem("authToken");

  const isLoggedIn = isAuthenticated || !!authToken;

  if (!isLoggedIn) {
    return (
      <AuthLayout>
        <div className="rounded-lg text-[hsl(222_84%_5%)] shadow-2xl border-0 bg-white/80 backdrop-blur-sm w-full max-w-md mx-auto">
          <ErrorState
            icon={<LuSearchX className="h-6 w-6" />}
            code="404"
            title="તમે શોધી રહ્યા છો તે પેજ મળ્યું નથી"
            description="અમે તમને જોઈએ તે પેજ શોધી શક્યા નથી. કૃપા કરીને URL તપાસો અથવા લોગિન કરીને આગળ વધો."
          >
            <Button
              variant="primary"
              className="w-full sm:w-auto"
              onClick={() => navigate(route.login)}
            >
              <LuLogIn className="h-4 w-4" />
              લોગિન પેજ પર જાઓ
            </Button>

            <Button
              variant="outline"
              className="w-full sm:w-auto"
              onClick={() => navigate(-1)}
            >
              <LuArrowLeft className="h-4 w-4" />
              પાછા જાઓ
            </Button>
          </ErrorState>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>પેજ મળ્યું નથી</h1>
      </div>

      <div className="space-y-4 md:space-y-6">
        <div className={cardClass}>
          <ErrorState
            icon={<LuSearchX className="h-6 w-6" />}
            code="404"
            title="તમે શોધી રહ્યા છો તે પેજ મળ્યું નથી"
            description="અમે તમને જોઈએ તે પેજ શોધી શક્યા નથી. કૃપા કરીને URL તપાસો અથવા ડેશબોર્ડ પર પાછા જાઓ."
          >
            <Button
              variant="primary"
              className="w-full sm:w-auto"
              onClick={() => navigate(route.dashboard)}
            >
              <LuHome className="h-4 w-4" />
              ડેશબોર્ડ પર જાઓ
            </Button>

            <Button
              variant="outline"
              className="w-full sm:w-auto"
              onClick={() => navigate(-1)}
            >
              <LuArrowLeft className="h-4 w-4" />
              પાછા જાઓ
            </Button>
          </ErrorState>
        </div>

        <QuickLinks />
      </div>
    </AppLayout>
  );
};
export default NotFoundPage;
